import { render } from "./detail_honor.vue?vue&type=template&id=32172741&scoped=true"
import script from "./detail_honor.vue?vue&type=script&lang=js"
export * from "./detail_honor.vue?vue&type=script&lang=js"

import "./detail_honor.vue?vue&type=style&index=0&id=32172741&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\hwh-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32172741"]])

export default __exports__